/**
 * Stato delle pagine Analisi prezzi (Amazon ed eBay) nell'URL: paese, ricerca, "solo seguiti",
 * filtro della pagina (buybox su Amazon, confronto su eBay), pagina e righe per pagina.
 * Con un refresh, o tornando da un'altra pagina, si riparte da dove si era.
 *
 * Uso: `mixins: [priceAnalysisRouteState('buybox')]`; nel `created` della pagina, prima di
 * caricare i paesi, `this.leggiStatoUrl()`. La pagina chiama `this.scriviStatoUrl()` a ogni
 * caricamento delle righe.
 */
const PER_PAGINA = [10, 25, 50, 100];

export function priceAnalysisRouteState(campoFiltro) {
	return {
		data() {
			return { paginaDaUrl: 1 };
		},
		methods: {
			leggiStatoUrl() {
				const q = this.$route.query;
				if (q.paese) this.marketplace = String(q.paese);
				if (q.q) {
					this.searchfield = String(q.q);
					this.search = String(q.q);
				}
				this.onlyFollowed = q.seguiti === '1';
				if (q.filtro) this[campoFiltro] = String(q.filtro);
				const perPage = parseInt(q.perPage, 10);
				if (PER_PAGINA.includes(perPage)) this.options.itemsPerPage = perPage;
				const page = parseInt(q.page, 10);
				this.paginaDaUrl = page > 1 ? page : 1;
				this.options.page = this.paginaDaUrl;
			},
			scriviStatoUrl() {
				const query = {};
				if (this.marketplace) query.paese = String(this.marketplace);
				if (this.search) query.q = this.search;
				if (this.onlyFollowed) query.seguiti = '1';
				if (this[campoFiltro]) query.filtro = String(this[campoFiltro]);
				if (this.options.page > 1) query.page = String(this.options.page);
				if (this.options.itemsPerPage !== 25) query.perPage = String(this.options.itemsPerPage);
				// pagina aperta da un'altra (es. consigli della scheda prodotto): il ritorno deve reggere un refresh
				if (this.$route.query.from) query.from = String(this.$route.query.from);
				if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) this.$router.replace({ query }).catch(() => {});
			},
			// la tabella, nata senza totale, puo' aver riportato la pagina a 1: si torna a quella dell'URL
			ripristinaPaginaUrl() {
				const pagina = this.paginaDaUrl;
				this.paginaDaUrl = 1;
				if (pagina > 1 && this.options.page !== pagina && this.total > (pagina - 1) * this.options.itemsPerPage) {
					this.options = { ...this.options, page: pagina };
				}
			},
		},
	};
}
